import 'regenerator-runtime/runtime';
import { call, cancel, select, takeEvery } from 'redux-saga/effects';
import { GlobalAction, GlobalActions, GlobalPut, isAzam } from '@ps20-frontend/shop-integration-redux';
import { GetGruppeRequest } from '@ps20/bff-models';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { ForkEffect } from '@redux-saga/core/effects';
import { IAppState } from '../localStore';
import { isSdwSession } from '../selectors/transientState.selector';
import { checkActionType } from './helpers/checkActionType';

export const getGruppeUrl = '/privatschutz/api/getgruppe';

export function* watchAmisCrmPersonenGruppeRequested(): Generator<ForkEffect> {
  yield takeEvery(
    GlobalActions.AMIS_CRM_PERSONENGRUPPE_REQUESTED,
    safeSaga(amisCrmPersonenGruppeRequested, App.SHOP),
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function* amisCrmPersonenGruppeRequested(action: GlobalAction<unknown>): any {
  const state: IAppState = yield select();
  if (isAzam(state.transientState.role) || isSdwSession(state)) {
    yield cancel();
  }
  checkActionType(action.type, GlobalActions.AMIS_CRM_PERSONENGRUPPE_REQUESTED);
  const { kundenverwaltungID, groupId } = action.payload as { kundenverwaltungID: string; groupId: string };

  if (kundenverwaltungID) {
    const body: GetGruppeRequest = {
      personId: kundenverwaltungID,
      groupId,
    };
    const globalPut = GlobalPut.getInstance();
    yield call(
      globalPut.put.bind(globalPut),
      new GlobalActions().doRequest({
        appId: App.SHOP,
        body,
        url: getGruppeUrl,
        successEvent: GlobalActions.AMIS_CRM_PERSONENGRUPPE_REQUEST_SUCCESSFUL,
        errorEvent: GlobalActions.AMIS_CRM_PERSONENGRUPPE_REQUEST_FAILED,
        noCache: true,
      }),
    );
  }
}
